/**
 * @Description: 客户端应用程序和打印机的关联信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  ApplicationPrintersModel,
  ApplicationPrintersSearchModel,
  ApplicationPrintersPageSearchModel,
  ApplicationPrintersAddModel,
  ApplicationPrintersUpdateModel,
  IdsModel
} from '@/model/product/ApplicationPrintersModel'

const baseUrl = Route.product + '/applicationPrinters'

/**
 * 搜索分页数据
 */
export const pageSearchApplicationPrinters = (param: ApplicationPrintersPageSearchModel) => {
  return https().request<RootObject<PageRespModel<ApplicationPrintersModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchApplicationPrinters = (param: ApplicationPrintersSearchModel) => {
  return https().request<RootObject<ApplicationPrintersModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getApplicationPrinters = (id: number) => {
  return https().request<RootObject<ApplicationPrintersModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addApplicationPrinters = (param: ApplicationPrintersAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateApplicationPrinters = (param: ApplicationPrintersUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeApplicationPrinters = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveApplicationPrinters = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
